// 劳动合同管理
import request from '@/plugins/axios'

// 分页列表
export function pageForMyApi(data) {
  return request({ url: '/laborContract/v1.0.0/pageForMy', method: 'post', data })
}
// 新增
export function addLaborContractApi(data) {
  return request({ url: '/laborContract/v1.0.0/add', method: 'post', data })
}
// 编辑
export function updateLaborContractApi(data) {
  return request({ url: '/laborContract/v1.0.0/update', method: 'post', data })
}
// 删除
export function deleteLaborContractApi(data) {
  return request({ url: '/laborContract/v1.0.0/delete', method: 'post', data })
}
// 作废（保留记录，状态置为作废）
export function voidLaborContractApi(data) {
  return request({ url: '/laborContract/v1.0.0/void', method: 'post', data })
}
// 续签
export function renewLaborContractApi(data) {
  return request({ url: '/laborContract/v1.0.0/renew', method: 'post', data })
}
// 概览看板
export function dashboardApi(data) {
  return request({ url: '/laborContract/v1.0.0/dashboard', method: 'post', data })
}
// 到期提醒
export function pageForRemindApi(data) {
  return request({ url: '/laborContract/v1.0.0/pageForRemind', method: 'post', data })
}
// 员工档案
export function pageForEmployeeApi(data) {
  return request({ url: '/laborContract/v1.0.0/pageForEmployee', method: 'post', data })
}
// 提醒设置-获取
export function getRemindSettingApi(data) {
  return request({ url: '/laborRemindSetting/v1.0.0/get', method: 'post', data })
}
// 提醒设置-保存
export function saveRemindSettingApi(data) {
  return request({ url: '/laborRemindSetting/v1.0.0/save', method: 'post', data })
}
// 重新提交审批（被驳回合同再次发起）
export function resubmitLaborContractApi(data) {
  return request({ url: '/laborContract/v1.0.0/resubmit', method: 'post', data })
}

// 劳动合同-待我审批列表
export function auditPageApi(data) {
  return request({ url: '/laborContractAuditRecord/v1.0.0/pageForAudit', method: 'post', data })
}
// 劳动合同-审批（通过/驳回）
export function auditApi(data) {
  return request({ url: '/laborContractAuditRecord/v1.0.0/audit', method: 'post', data })
}
// 劳动合同-审批详情
export function auditDetailApi(data) {
  return request({ url: '/laborContractAuditRecord/v1.0.0/detail', method: 'post', data })
}
